<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
const props = defineProps({
  isMobile:{
    type: Boolean,
    default: false,
  }
})
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <section class="guide-box">
            <div 
              class="guide-box__title"
              :class="{mobile: isMobile}"
            >
              <div class="box-title__keyword">분석의 확장</div>
              <span class="box-title__txt">진로와 반려친구, 일상의 조화까지!</span>
            </div>

            <div class="box-content gray">
              <div class="cont-top_txt">
                낭만성향분석은
                <span class="highlight"
                  >사주원국의 구조, 오행의 생극제화, 격국과 용신 분석을 바탕</span
                >으로<br />
                실생활에 연결된 제안을 함께 드리고 있습니다.
              </div>
              <div class="box-img">
                <div class="guide-star-img" />
              </div>
            </div>
            <div>
              <div v-if="!props.isMobile" class="box-content border-box">
                <div class="icon-course"></div>
                <div class="border-box__content">
                  <div class="border-box__title">진로 추천</div>
                  <div>
                    격국과 용신의 특성, 기운을 참고하여 성향에 어울릴 수 있는 진로방향을 탐색해보실 수
                    있도록
                    <span class="highlight">우선 추천</span>과
                    <span class="highlight">보조 추천</span>으로 나누어 안내해 드립니다.
                  </div>
                </div>
              </div>
              <div v-else class="box-content border-box">
                <div 
                  class="border-box__content mobile">
                  <div class="border-box__title"><div class="icon-course"></div>진로 추천</div>
                  <div>
                    격국과 용신의 특성, 기운을 참고하여 성향에 어울릴 수 있는 진로방향을 탐색해보실 수
                    있도록
                    <span class="highlight">우선 추천</span>과
                    <span class="highlight">보조 추천</span>으로 나누어 안내해 드립니다.
                  </div>
                </div>
              </div>
            </div>

            <div>
            <div v-if="!props.isMobile" class="box-content border-box">
              <div class="icon-pet"></div>
              <div class="border-box__content">
                <div class="border-box__title">반려친구 추천</div>
                  <div>
                    성향 분석 결과와 용신·희신의 흐름을 고려하여, 자연과의 어울림을 고민하는 분들께
                    반려동물과 반려식물 친구를 안내해드립니다.
                  </div>
                  <div class="border-box__description">
                    ※ 이미 반려생활 중인 분들께도 또 다른 관점에서 자신을 이해해보는 하나의 참고
                    자료로 활용해보시길 권합니다.
                  </div>
              </div>
            </div>
            <div v-else class="box-content border-box">
              <div class="border-box__content mobile">
                <div class="border-box__title"><div class="icon-pet"></div>반려친구 추천</div>
                <div class="g-4">
                  <div>
                    성향 분석 결과와 용신·희신의 흐름을 고려하여, 자연과의 어울림을 고민하는 분들께
                    반려동물과 반려식물 친구를 안내해드립니다.
                  </div>
                  <div class="border-box__description">
                    ※ 이미 반려생활 중인 분들께도 또 다른 관점에서 자신을 이해해보는 하나의 참고
                    자료로 활용해보시길 권합니다.
                  </div>
                </div>
              </div>
            </div>
            </div>


            <div class="box-body">
              <div class="box-body__txt">
                낭만성향분석은 이와 같이 명리학의 핵심 원리를 바탕으로 일상의 다양한 순간을
                탐색해보는 길을 따뜻하게 열어가고자 합니다.
              </div>
            </div>
          </section>
        </div>
      </VCard>
    </VCol>

    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <section class="guide-box">
            <div
              class="guide-box__title"
              :class="{mobile: isMobile}"
            >
              <div class="box-title__keyword">성향 분석의 활용</div>
              <span class="box-title__txt">나를 이해하고 조율하는 이정표로!</span>
            </div>

            <div class="box-content gray">
              <div class="cont-top_txt">
                낭만성향분석은 타고난 기질과 시기에 따라 달라질 수 있는 성향을 함께 해석함으로써,<br />보다
                현실적이고 유연한 자기이해의 방향을 제안합니다.
              </div>
            </div>

            <div class="box-body">
              <span class="box-body__txt">
                중심 성향뿐 아니라, 유사 성향과 시기별 변화 양상까지 열린 시선으로 함께
                살펴본다면,<br />나에 대한 이해는 한층 깊어지고 유연해질 수 있습니다.
              </span>
              <span class="box-body__txt">
                또한 성향은 시기적 에너지에 따라 강조점이 달라질 수 있기 때문에,
                <span class="highlight">새로운 흐름이 시작되는 시점인 신년이나 대운변화 시점</span
                >에 한 번쯤 다시 살펴보는 것도 좋은 자기 점검이 될 수 있습니다.
              </span>
            </div>

            <div class="box-content border-box sm">
              <div class="icon-speaker"></div>
              <div class="border-box__content">
                시간의 흐름에 따라 변화하는<br/>
                에너지(대운, 세운 등)를 반영한 추가 성향 분석 서비스도 곧 제공해드릴 예정입니다!
              </div>
            </div>

            <div class="guide-quote">
              <div class="icon-quote"></div>
              <div>
                분석 결과가
                <span class="txt-bold"
                  >‘나를 규정짓는 단 하나의 정의’가 아니라
                  <div class="text-underline"></div></span
                ><br />
                이미 내 안에 존재하지만<br />
                <span class="txt-bold highlight"
                  >아직 조명되지 않았던 가능성을 더 깊이 이해할 수 있는
                  <div class="text-underline"></div></span
                ><br />
                작은 빛으로 다가가기를 바랍니다.
              </div>
            </div>

            <div 
              class="guide-outro bg-highlight"
              :class="{mobile: isMobile}"
            >
              <div 
                class="img-nangmanee"
                :class="{mobile: isMobile}"
              ></div>
              <div 
                class="guide-outro__content"
                :class="{mobile: isMobile}"
              >
                <div class="guide-outro__title">낭만만세력은</div>
                <div class="guide-outro__text">
                  이 성향분석이 삶의 방향을 조율해가는<br />
                  따뜻한 이정표가 될 수 있도록 지속적으로 연구하고,<br />
                  더 나은 서비스로 발전시켜 나가겠습니다.
                </div>
              </div>
            </div>
          </section>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
<style scoped lang="scss">
@import '@/assets/nangman_style/_analysis_main_color.scss';
.arrow-icon {
  width: 24px;
  height: 24px;
  background: url('@manseImages/icon-double-arrow.svg') center center no-repeat;
  background-size: contain;
}
.guide-star-img {
  height: 160px;
  aspect-ratio: 9/8;
  background: url('@manseImages/personality/prsonaity-guidle-star.png') center center no-repeat;
  background-size: contain;
}
.guide-eight-img {
  width: 270px;
  aspect-ratio: 270/116;
  background: url('@manseImages/personality/personality-guide-eight.png') center center no-repeat;
  background-size: contain;
}
.icon-course {
  width: 60px;
  height: 60px;
  background: url('@manseImages/personality/icon-recommend_course.svg') center center no-repeat;
  background-size: contain;
}
.icon-pet {
  width: 60px;
  height: 60px;
  background: url('@manseImages/personality/icon-recommend_pet.svg') center center no-repeat;
  background-size: contain;
}
.icon-speaker {
  width: 18px;
  height: 18px;
  background: url('@manseImages/personality/icon-speaker_orange.svg') center center no-repeat;
  background-size: contain;
}
.icon-quote {
  width: 28px;
  height: 22px;
  background: url('/src/assets/images_manse/icon_quotes.svg') center center no-repeat;
  background-size: contain;
}
.img-nangmanee {
  width: 140px;
  height: 140px;
  background: url('@manseImages/personality/img-nangmanee.png') no-repeat;
  background-size: contain;
  &.mobile{
    width: 100px;
    height: 100px;
  }
}
.guide-quote {
  padding: 20px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  .txt-bold {
    position: relative;
    font-weight: 700;
    .text-underline {
      position: absolute;
      right: 0;
      bottom: -2px;
      width: 100%;
      height: 8px;
      opacity: 0.15;
      background: var(--Gray-800, #333);
      z-index: -1;
      border-radius: 0;
    }
  }
  .txt-bold.highlight {
    .text-underline {
      background: $analysis-personality;
    }
  }
}
.guide-outro {
  padding: 20px 32px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  &.mobile{
    flex-direction: column;
    gap: 20px;
    padding: 20px 24px;
    align-items: center;
    justify-content: center;
  }
  .guide-outro__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    line-height: 24px;
    &.mobile{
      align-items: center;
      text-align: center;
    }
  }
  .guide-outro__title {
    color: $analysis-personality;
    font-weight: 700;
  }
  .guide-outro__text {
    color: var(--Gray-800, #333);
    font-weight: 400;
  }
}
</style>
